/*
*   List of Actions with TYPE that should be passed from accreditation.reducer.js to audit.reducer.js
 */

import set from "lodash/set";
import {IDS} from "../requirements-assessment/requirements-assessment-action-id.constants";

export const PREFIX = 'ACCREDITATION_AUDIT';

export const TYPES = {
    FETCH_SCHEDULE:                     `${PREFIX}_FETCH_SCHEDULE`,
    FETCH_HEAD_OFFICE_DETAILS:          `${PREFIX}_FETCH_HEAD_OFFICE_DETAILS`,
    FETCH_SITE_LOCATION_DETAILS:        `${PREFIX}_FETCH_SITE_LOCATION_DETAILS`,
    FETCH_SITE_CONTACT_CANDIDATES:      `${PREFIX}_FETCH_SITE_CONTACT_CANDIDATES`,
    RESET_SCHEDULE:                     `${PREFIX}_RESET_SCHEDULE`,
    // FETCH_USER_DEAILS:                  `${PREFIX}_FETCH_USER_DEAILS`,
    REFRESH_AUDIT_DETAILS:              `${PREFIX}_REFRESH_AUDIT_DETAILS`,
    ADD_AUDIT_ASSIGNEE:                 `${PREFIX}_ADD_AUDIT_ASSIGNEE`,
    SELECT_NEW_AUDIT_FISCAL_YEAR:       `${PREFIX}_SELECT_NEW_AUDIT_FISCAL_YEAR`,
    SELECT_NEW_AUDIT_REQUIREMENT:           `${PREFIX}_SELECT_NEW_AUDIT_SECTION`,
    PRESELECT_REQUIREMENT_FOR_NEW_AUDIT:    `${PREFIX}_PRESELECT_SECTION_FOR_NEW_AUDIT`,
    SET_AUDIT_DUE_DATE:                       `${PREFIX}_SET_DUE_DATE`,
    REMOVE_AUDIT_ASSIGNEE:              `${PREFIX}_REMOVE_AUDIT_ASSIGNEE`,
    RESET_EVIDENCE_PROVIDER:            `${PREFIX}_RESET_EVIDENCE_PROVIDER`,
    RESET_ADD_AUDIT_FIELDS:             `${PREFIX}_RESET_ADD_AUDIT_FIELDS`,
    RESET_ADD_AUDIT_ASSIGNEES:          `${PREFIX}_RESET_ADD_AUDIT_ASSIGNEES`,
    SET_REQUIREMENT_APPLICABILITY:          `${PREFIX}_SET_SECTION_APPLICABILITY`,
};
